import React, { useCallback, useState } from 'react';
import { SCHEDULE_SHIP_DATE_MESSAGE } from 'utils/constants';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import styled from '@emotion/styled';

const ScheduledShippingDateMessage = styled.span`
  padding: 0 5px;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.secondary};
  cursor: pointer;
`;
const PopoverComponent = styled(Typography)`
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.info};
`;

const MissingScheduledShippingDate = () => {
  const [PopoverElement, setPopoverElement] = useState(null);
  const [openPopover, setOpenPopover] = useState(false);

  const handlePopoverOpen = useCallback(
    (event) => {
      setOpenPopover(true);
      setPopoverElement(event.currentTarget);
    },
    [setOpenPopover, setPopoverElement]
  );

  const handlePopoverClose = useCallback(() => {
    setOpenPopover(false);
    setPopoverElement(null);
  }, [setOpenPopover, setPopoverElement]);

  return (
    <>
      <ScheduledShippingDateMessage
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        What is my scheduled ship date ?
      </ScheduledShippingDateMessage>
      <Popover
        style={{ pointerEvents: 'none' }}
        open={openPopover}
        anchorEl={PopoverElement}
        transformOrigin={{
          vertical: 60,
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <PopoverComponent>{SCHEDULE_SHIP_DATE_MESSAGE}</PopoverComponent>
      </Popover>
    </>
  );
};
export { MissingScheduledShippingDate };
